export default {
  // Reflete a ordem escolhida de exibição dos atributos na tela
  // Mudar quando a ordem de exibição não reflete a ordem de cadastro
  attrDisplayOrder: [1, 2, 3],

  // Define quais atributos serão marcados logo de início
  // Com base no attrDisplayOrder acima, marque true ou false para cada um deles:
  // true: atributo deve ser marcado a primeira opção válida quando carrega o formulário
  // false: atributo não deve ser marcado quando carrega o formulário, aguarda ação do buyer
  attrMarkFirst: [true, true, true],

  // Define a quantidade limite para exibir aviso de últimas unidades
  lastUnitsLimit: 3,

  // Venda por Locais: alterar para habilitar a funcionalidade - true/false 
  useLocals: false,

  // Define se, por padrão, deve exibir o preço da variante mais barata.
  // Se for false, usa a primeira variante disponível
  priceDefaultCheaper: true,

  // Define se, por padrão, deve-se marcar os atributos da variante mais barata ao carregar um form de compra,
  // ao invés de marcar as primeiras opções disponíveis. "main" é para a página do produto, "quickview" é para a compra rápida do site
  markDefaultCheaper: {
    main: false,
    quickview: false
  },

  // Venda por Assinatura: alterar para habilitar a funcionalidade - true/false
  // Se for true, definir atributo referente ao plano vindi
  // Necessário cadastrar uma tag "assinatura" e vincular aos produtos
  useSubscription: true,
  attrSubscription: 2,
}